// eslint-disable-next-line no-restricted-syntax
export enum Resources {
  REQUIREMENTS = "requirements",
  WORKER_DOCUMENTS = "documents",
  LICENSES = "licenses",
  DISTRIBUTION_URL = "distribution-url",
  PRESIGNED_URL = "presigned-url",
  REJECTION_MAPPINGS = "rejection-mappings",
  DOCUMENT_DOWNLOAD = "document-download",
  HCP_DOCUMENT_ZENDESK_TICKET = "document-zendesk-ticket",
}
